export default __webpack_public_path__ + "static/under-construction-72a47a442a5dc76e93b906778c139ecc.png";